import React from 'react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { formatPrice } from './constants';

// Valuation Cost Summary Component
const ValuationCostSummary = ({ 
  damagedParts, 
  formData, 
  onFormChange 
}) => {
  // Calculate totals
  const partsCost = damagedParts.reduce((sum, p) => sum + (parseFloat(p.estimated_cost) || 0), 0);
  const laborCost = parseFloat(formData.labor_cost) || 0;
  const paintCost = parseFloat(formData.paint_cost) || 0;
  const otherCosts = parseFloat(formData.other_costs) || 0;
  const subtotal = partsCost + laborCost + paintCost + otherCosts;
  const taxRate = parseFloat(formData.tax_rate) || 13;
  const taxAmount = subtotal * (taxRate / 100);
  const total = subtotal + taxAmount;

  return (
    <div className="p-4 space-y-4">
      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <Label>Mano de Obra (₡)</Label>
          <Input
            type="number"
            value={formData.labor_cost}
            onChange={(e) => onFormChange('labor_cost', parseFloat(e.target.value) || 0)}
            data-testid="labor-cost-input"
          />
        </div>
        <div>
          <Label>Pintura (₡)</Label>
          <Input
            type="number"
            value={formData.paint_cost}
            onChange={(e) => onFormChange('paint_cost', parseFloat(e.target.value) || 0)}
            data-testid="paint-cost-input"
          />
        </div>
        <div>
          <Label>Otros Costos (₡)</Label>
          <Input
            type="number"
            value={formData.other_costs}
            onChange={(e) => onFormChange('other_costs', parseFloat(e.target.value) || 0)}
            data-testid="other-costs-input"
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label>IVA (%)</Label>
          <Input
            type="number"
            value={formData.tax_rate}
            onChange={(e) => onFormChange('tax_rate', parseFloat(e.target.value) || 13)}
            data-testid="tax-rate-input"
          />
        </div>
        <div>
          <Label>Días Estimados de Reparación</Label>
          <Input
            type="number"
            value={formData.estimated_repair_days}
            onChange={(e) => onFormChange('estimated_repair_days', parseInt(e.target.value) || '')}
            placeholder="Ej: 5"
            data-testid="repair-days-input"
          />
        </div>
      </div>

      {/* Totals Summary */}
      <Card className="p-4 bg-slate-50 border-slate-200">
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-slate-600">Repuestos ({damagedParts.length} partes)</span>
            <span className="font-medium">{formatPrice(partsCost)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-600">Mano de obra</span>
            <span className="font-medium">{formatPrice(laborCost)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-600">Pintura</span>
            <span className="font-medium">{formatPrice(paintCost)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-600">Otros</span>
            <span className="font-medium">{formatPrice(otherCosts)}</span>
          </div>
          <div className="border-t pt-2 flex justify-between text-sm">
            <span className="text-slate-600">Subtotal</span>
            <span className="font-medium">{formatPrice(subtotal)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-600">IVA ({taxRate}%)</span>
            <span className="font-medium">{formatPrice(taxAmount)}</span>
          </div>
          <div className="border-t pt-2 flex justify-between">
            <span className="font-semibold text-slate-900">TOTAL ESTIMADO</span>
            <span className="font-bold text-xl text-purple-600">{formatPrice(total)}</span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ValuationCostSummary;
